import {
  LIST_BRANCH_PHARMACY_PRICE_REQUEST,
  LIST_BRANCH_PHARMACY_PRICE_SUCCESS,
  LIST_BRANCH_PHARMACY_PRICE_FAIL,
  PATCH_BRANCH_PHARMACY_PRICE_REQUEST,
  PATCH_BRANCH_PHARMACY_PRICE_SUCCESS,
  PATCH_BRANCH_PHARMACY_PRICE_FAIL,
  DETAIL_BRANCH_PHARMACY_PRICE_REQUEST,
  DETAIL_BRANCH_PHARMACY_PRICE_SUCCESS,
  DETAIL_BRANCH_PHARMACY_PRICE_FAIL
} from '../../constants/branch-pharmacy-price'

const initialState = {
  loadingPharmacyPrice: false,
  loadingDetailPharmacyPrice: false,
  loadingPatchPharmacyPrice: false,
  PharmacyPrices: [],
  PharmacyPrice: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const pharmacyPriceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_BRANCH_PHARMACY_PRICE_REQUEST:
      return { ...state, loadingPharmacyPrice: true }
    case LIST_BRANCH_PHARMACY_PRICE_SUCCESS:
      return {
        ...state,
        loadingPharmacyPrice: false,
        PharmacyPrices: action.payload,
        pageable: action.pageable
      }
    case LIST_BRANCH_PHARMACY_PRICE_FAIL:
      return {
        ...state,
        loadingPharmacyPrice: false,
        error: action.payload
      }
    case PATCH_BRANCH_PHARMACY_PRICE_REQUEST:
      return { ...state, loadingPatchPharmacyPrice: true }
    case PATCH_BRANCH_PHARMACY_PRICE_SUCCESS:
      return {
        ...state,
        loadingPatchPharmacyPrice: false,
        PharmacyPriceDetail: action.payload,
        pageable: action.pageable
      }
    case PATCH_BRANCH_PHARMACY_PRICE_FAIL:
      return {
        ...state,
        loadingPatchPharmacyPrice: false,
        error: action.payload
      }
    case DETAIL_BRANCH_PHARMACY_PRICE_REQUEST:
      return {
        ...state,
        loadingDetailPharmacyPrice: true,
        error: null,
        PharmacyPrice: {}
      }
    case DETAIL_BRANCH_PHARMACY_PRICE_SUCCESS:
      return {
        ...state,
        loadingDetailPharmacyPrice: false,
        PharmacyPrice: action.payload,
        error: null
      }
    case DETAIL_BRANCH_PHARMACY_PRICE_FAIL:
      return {
        ...state,
        loadingDetailPharmacyPrice: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default pharmacyPriceReducer
